var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.006,
    height: 20.877,
    viewBox: "0 0 32.006 20.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#525252;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -89.012)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.735 90.066)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M342.96,105.876l-11.251,9.369,11.27,7.5V106.087A1.266,1.266,0,0,0,342.96,105.876Z",
    transform: "translate(-331.709 -105.876)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 100.28)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.721,269.264,18.3,270.445a3.593,3.593,0,0,1-4.6,0l-1.418-1.181L0,277.44v.168a1.267,1.267,0,0,0,1.265,1.265H30.74a1.267,1.267,0,0,0,1.265-1.265v-.168Z",
    transform: "translate(0 -269.264)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.072 89.012)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.82,89.012H17.336a.193.193,0,0,0-.119.343L28.8,99l0,0,1.784,1.486a2.328,2.328,0,0,0,2.98,0L46.939,89.355A.193.193,0,0,0,46.82,89.012Z",
    transform: "translate(-17.147 -89.012)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 90.066)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.019,105.876a1.265,1.265,0,0,0-.019.211v16.658l11.27-7.5Z",
    transform: "translate(0 -105.876)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5310dfff6ca69bc34ee89397bc1afd86.svg";
export { ForwardRef as ReactComponent };